import _throttle from "lodash/throttle";
import { zxcvbn } from '@zxcvbn-ts/core';
var PasswordScore = /*#__PURE__*/function (PasswordScore) {
  PasswordScore[PasswordScore["Weak0"] = 0] = "Weak0";
  PasswordScore[PasswordScore["Weak1"] = 1] = "Weak1";
  PasswordScore[PasswordScore["Moderate"] = 2] = "Moderate";
  PasswordScore[PasswordScore["Good"] = 3] = "Good";
  PasswordScore[PasswordScore["Strong"] = 4] = "Strong";
  return PasswordScore;
}(PasswordScore || {});
const THROTTLE_WAIT_MILLISECONDS = 300;
const PASSWORD_SCORE_LABELS = ['Weak', 'Weak', 'Moderate', 'Good', 'Strong'];
const isPasswordWeak = score => score === PasswordScore.Weak0 || score === PasswordScore.Weak1;
const isPasswordModerate = score => score === PasswordScore.Moderate;
const isPasswordGood = score => score === PasswordScore.Good;
const isPasswordStrong = score => score === PasswordScore.Strong;
const checkStrength = _throttle(zxcvbn, THROTTLE_WAIT_MILLISECONDS);
const getPasswordScore = async (password, isAllPasswordRequirementsCompleted) => {
  const strengthResult = await checkStrength(password);
  const passwordScore = strengthResult === null || strengthResult === void 0 ? void 0 : strengthResult.score;
  if (isPasswordStrong(passwordScore) && !isAllPasswordRequirementsCompleted) {
    return PasswordScore.Good;
  }
  return passwordScore !== null && passwordScore !== void 0 ? passwordScore : PasswordScore.Weak0;
};
export { PasswordScore, PASSWORD_SCORE_LABELS, getPasswordScore, isPasswordWeak, isPasswordModerate, isPasswordGood, isPasswordStrong };